import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, InputNumber, Row, Col, message, DatePicker } from 'antd';
import dayjs from 'dayjs';
import * as adminactions from 'store/actions/AuthActions';

const { TextArea } = Input;

const CommissionModal = ({ visible, onCancel, onSuccess, employeeId, editingRecord, dateOfJoining }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    // Disable dates before joining date
    const disabledDate = (current) => {
        if (!dateOfJoining) return false;
        return current && current < dayjs(dateOfJoining).startOf('day');
    };

    useEffect(() => {
        if (visible) {
            if (editingRecord) {
                form.setFieldsValue({
                    ...editingRecord,
                    effective_date: editingRecord.effective_date ? dayjs(editingRecord.effective_date) : null
                });
            } else {
                form.resetFields();
            }
        }
    }, [visible, editingRecord, form]);

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const data = {
                employee: employeeId,
                effective_date: values.effective_date.format('YYYY-MM-DD'),
                commission_title: values.commission_title,
                commission_amount: values.commission_amount,
                notes: values.notes || null
            };

            if (editingRecord) {
                await adminactions.updateCommission(editingRecord.id, data);
                message.success('Commission updated successfully');
            } else {
                await adminactions.createCommission(data);
                message.success('Commission created successfully');
            }

            onSuccess();
            form.resetFields();
        } catch (error) {
            message.error('Failed to save commission');
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={editingRecord ? 'Edit Commission' : 'Add Commission'}
            open={visible}
            onCancel={onCancel}
            onOk={() => form.submit()}
            confirmLoading={loading}
            width={600}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="effective_date"
                            label="Effective Date"
                            rules={[{ required: true, message: 'Please select effective date' }]}
                        >
                            <DatePicker style={{ width: '100%' }} disabledDate={disabledDate} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="commission_amount"
                            label="Amount"
                            rules={[{ required: true, message: 'Please enter amount' }]}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                step={100}
                                prefix="₹"
                                placeholder="Enter commission amount"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="commission_title"
                            label="Commission Title"
                            rules={[{ required: true, message: 'Please enter commission title' }]}
                        >
                            <Input placeholder="e.g., Sales Commission, Performance Bonus" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="notes"
                            label="Notes"
                        >
                            <TextArea rows={3} placeholder="Enter any notes" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default CommissionModal;
